/*
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
// eslint-disable-next-line
import { Amplify, API} from "aws-amplify";
import { ConfigUtils } from "./ConfigUtils";
import { MediaUtils } from "./MediaUtils";
import { LogUtils } from "./LogUtils";
import axios from "axios";

Amplify.configure({
  API: {
    endpoints: [
      {
        name: process.env.REACT_APP_API_NAME,
        endpoint: process.env.REACT_APP_API_URL
      }
    ]
  }
});

export interface FrameUploadUrl {
  readonly filePath: string;
  readonly expiredAt: number;
  readonly url: string;
  readonly contentType: string;
  readonly fileUrl: string;
}

export interface ChallengeMetadata {
  readonly id: string;
  readonly token: string;
  readonly type: string;
  readonly params: unknown;
  readonly frameUploadUrls: FrameUploadUrl[];
}

export interface ChallengeResult {
  readonly success: boolean;
}

export class APIUtils {
  static async getAuthorizationHeader(contentType: string) {
    return {
      plat: "android",
      osver: "31",
      appver: "35",
      //authorization: "5eb3bb85613d406d83ec3347baf4c325",
      "Content-Type": contentType
    };
  }

  static async startChallenge(challengeType: string): Promise<ChallengeMetadata> {
    const path = ConfigUtils.getConfig().API_START_ENDPOINT;
    const init = {
      headers: await APIUtils.getAuthorizationHeader("application/json"),
      body: {
        imageWidth: MediaUtils.getMediaStreamInfo().actualWidth,
        imageHeight: MediaUtils.getMediaStreamInfo().actualHeight
      }
    };

    if (challengeType) {
      // @ts-ignore
      init.body["challengeType"] = challengeType;
    }

    LogUtils.info("startChallenge:");
    LogUtils.info(init);
    return API.post(ConfigUtils.getConfig().API_NAME, path, init).then(result => {
      LogUtils.info(result);
      return result.data;
    });
  }

  static async putChallengeFrame(
    challengeId: string,
    token: string,
    blob: Blob,
    uploadUrl: string,
    timestamp: number
  ): Promise<void> {
    const headerConfig = {
      headers: {
        "Content-Type": "image/jpeg"
      }
    };
    LogUtils.info("putChallengeFrame:");
    await axios.put(uploadUrl, blob, headerConfig).then(function(response: any) {
      LogUtils.info(response);
      return response.data;
    });
  }

  static async verifyChallenge(challengeId: string, token: string): Promise<ChallengeResult> {
    const path: string = ConfigUtils.getConfig().API_VERIFY_ENDPOINT_PATTERN.replace("{challengeId}", challengeId);
    const init = {
      headers: {
        plat: "android",
        osver: "31",
        appver: "35"
      },
      body: {
        id: challengeId,
        type: 2,
        token: token
      }
    };
    return API.post(ConfigUtils.getConfig().API_NAME, path, init).then(result => {
      console.log("verifyChallenge:", result);
      return { success: result.code === 0 && result.data.isSuccess };
    });
  }
}
